import { z } from 'zod';
/**
 * 개인 사용자 그룹 — 일반 사용자가 직접 만들어 사람을 담는 공유 대상.
 * 관리자 RBAC 역할(roles) 과 별개. owner 본인만 보고 관리한다.
 */
/** 사용자 검색/멤버 표시용 속성 1개 (관리자가 디렉터리 노출 허용한 것만). */
export const DirectoryAttributeSchema = z.object({
    label: z.string(),
    value: z.string(),
});
/**
 * 디렉터리(사용자 검색) 1건 — 이름 + 이메일/아이디 + 노출 허용된 속성.
 * 동명이인 구분을 위해 속성 칩을 함께 표시한다.
 */
export const DirectoryUserSchema = z.object({
    id: z.string().uuid(),
    displayName: z.string(),
    email: z.string(),
    attributes: z.array(DirectoryAttributeSchema),
});
export const DirectorySearchResponseSchema = z.object({
    users: z.array(DirectoryUserSchema),
});
/** 그룹 목록 항목 (멤버 수 포함). */
export const UserGroupSummarySchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    memberCount: z.number().int().nonnegative(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const UserGroupSummaryListSchema = z.object({
    groups: z.array(UserGroupSummarySchema),
});
/** 그룹 상세 — 멤버 전체 포함. */
export const UserGroupDetailSchema = UserGroupSummarySchema.extend({
    members: z.array(DirectoryUserSchema),
});
export const CreateUserGroupRequestSchema = z.object({
    name: z.string().trim().min(1).max(80),
});
export const RenameUserGroupRequestSchema = CreateUserGroupRequestSchema;
export const GroupMembersRequestSchema = z.object({
    userIds: z.array(z.string().uuid()).min(1).max(500),
});
//# sourceMappingURL=user-groups.js.map